import React, { useState, useMemo } from 'react';
import useSystemOrganization from '../../hooks/system/query/organization/useSystemOrganization';
import { MovaticFieldGroupAsyncMultiSelect } from '../Redesing/movatic-field-group';
import useSearchDebounce from '../../hooks/search/useSearchDebounce';
import { ISystem } from '../../ts/interface/system.interface';

interface SystemOption {
  value: string;
  name: string;
  original: ISystem;
}

function OrganizationSystemMultiSelect({
  organization_id,
  description,
  selectedSystem,
  onChange,
}: {
  organization_id: string;
  description?: string;
  selectedSystem?: { value: string; label: string; original: ISystem }[];
  onChange: (system: ISystem[]) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const debouncedSearch = useSearchDebounce(searchTerm, 500);

  const { data, isLoading, isRefetching } = useSystemOrganization(
    {},
    {
      organization_id: organization_id,
      search: debouncedSearch,
    }
  );

  const options = useMemo(
    () =>
      data?.systems?.map((system: ISystem) => ({
        value: system.gid,
        name: system.name,
        original: system,
      })) || [],
    [data?.systems]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <MovaticFieldGroupAsyncMultiSelect
      isLoading={isLoading || isRefetching}
      label="System"
      description={description}
      name="system"
      id="system"
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      options={options}
      value={selectedSystem?.map((system) => ({
        value: system.value,
        name: system.label,
        original: system.original,
      }))}
      onChange={(_event: React.SyntheticEvent, newValue: SystemOption[] | null) => {
        const newSystems = newValue?.map((system: SystemOption) => system.original);
        if (newSystems && newSystems.length > 0) {
          onChange(newSystems);
          setSearchTerm('');
        } else {
          onChange([]);
        }
        setIsOpen(false);
      }}
      handleSearch={handleSearch}
    />
  );
}

export default OrganizationSystemMultiSelect;
